import { render, staticRenderFns } from "./JoinTextObject.vue?vue&type=template&id=7494c518&scoped=true&"
import script from "./JoinTextObject.vue?vue&type=script&lang=ts&"
export * from "./JoinTextObject.vue?vue&type=script&lang=ts&"
import style0 from "./JoinTextObject.vue?vue&type=style&index=0&id=7494c518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494c518",
  null
  
)

export default component.exports